import { LocalStorage } from '@axiom/ui';

const STORE_NAMES = {
  paginationActionDate: 'pagination_action_date',
  showPricing: 'show_pricing',
  intakeIntroShown: 'intake_intro_shown',
};

export const localStorageUtil = {
  paginationActionDate: (defaults = null) =>
    LocalStorage(STORE_NAMES.paginationActionDate, defaults),
  showPricing: (defaults = false) =>
    LocalStorage(STORE_NAMES.showPricing, defaults),
  intakeIntroShown: (userId, defaults = false) =>
    LocalStorage(`${STORE_NAMES.intakeIntroShown}:${userId}`, defaults),
};
